import type { ReactNode } from 'react';

import { cn } from '@nesso/ui/lib/utils';

export function SettingsColumn({
    className,
    children,
}: {
    className?: string;
    children: ReactNode;
}) {
    return (
        <div className={cn('w-full max-w-190 pt-4 sm:pt-6 md:pt-9 px-4 sm:px-10', className)}>
            {children}
        </div>
    );
}
